export const TEST_ID = 'infoIcon';
